// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/css/background-colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}


.table-header-color .table .left-header {
  background-color: #489469 !important;
}
.table-header-color .table .right-header {
  background-color: #82479b !important;
}

.table-header-color .table .thead-left {
  background-color: #18723f !important;
}

.table-header-color .table .thead-right {
 
  background-color: #603174 !important;
}


.table-header-color .table .thead-audit {
  background-color: #0a2339 !important
}

.table-header-color .table .audit-header {
  background-color: #3d4a56 !important;
}





@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: gray;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.custom-alert-warning {
  color: #856404;
  /* Dark yellow text color */
  background-color: #fff3cd;
  /* Light yellow background color */
  border-color: #ffeeba;
  /* Light yellow border color */
}

.custom-alert-warning .btn-close {
  filter: invert(50%);
  /* Optional: Adjust the button color if needed */
}


/* Header.css */
.header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 15px;
  color: var(--whitefont-color);
  /*header text */
  background-color: var(--header-bg);
  padding-bottom: 5px;
  /* Optional: Adjust padding to create space between the header and the line */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);
  /* Smooth shadow effect */
}

.logo-default-header {
  color: var(--ProductName-color);
  margin-bottom: 0px;
  margin-top: 0px;
}

.bell-default header {
  color: var(--blackfont-color);
}

.count-default-header {
  color: var(--blackfont-color);
}

.notification-canvas-count {
  color: var(--blackfont-color);
}


/* ===========Header Downside border============= */
.header-container::before {
  content: '';
  position: absolute;
  bottom: 0;
  /* Position it at the bottom */
  left: 0;
  width: 100%;
  height: 0px;
  /* Height of the border */
  /* background-color: #E67016;  header border bottom Color */
}

/* ===========End============= */

/* Header name changed with below css */
.header-name {
  font-family: 'Logirent', sans-serif;
}



.text-center1 {
  font-family: 'Logirent Demo', sans-serif;
}
 
.header-text{
  font-family: 'Logirent Demo', sans-serif;
  font-size: var(--ProductName-fontsize);
}

.custom-margin {
  margin-left: 4.3rem !important;
  margin-bottom: -4px;
}



.logo1 {
  /* position: absolute; 
  left: 1px;
  top: 3px; 
  width: 35px; 
  height: auto; 
  object-fit: contain; 
  margin-left: 10px;  */
  /* 
    position: absolute;
    left: 9px;
    top: 0px;
    width: 25px;
    height: auto;
    object-fit: contain;
    margin-left: 10px;
    margin-top: 4px; */
  position: absolute;
  left: 1px;
  top: -1px;
  width: 54px;
  height: auto;
  object-fit: contain;
  margin-left: 10px;
  /* margin-top: 4px; */
}


.logo2{
  position: absolute;
  /* left: -41px; */
  top: -7px;
  width: 57px;
  height: auto;
  object-fit: contain;
  margin-left: 70px;
  width: 61px;
}



.logo3{
  position: absolute;
  /* left: -41px; */
  top: -2px;
  width: 57px;
  height: auto;
  object-fit: contain;
  margin-left: 0px;
  margin-right: 20px;
  width: 61px;
}

.header-name1 {

  margin-left: 45px;
}


.profile-icon {
  cursor: pointer;
  /* Optional: Add cursor pointer */
}

/* Header.css */
.profile-icon {
  font-size: 2rem;
  /* Adjust the size as needed */
}

.footer-name {
  font-size: 10px;
  /* Adjust the font size as needed */
  padding-left: 10px;
  /* Adjust the padding as needed */
  margin-left: 10px;
  /* Adjust the margin as needed */
}



/* Home.css */

.home-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f0f0f0e6;
}

.content {
  flex: 1 1;
  /* Add styles for your page content if needed */
}

.footer {
  margin-top: auto;
}

.content {
  display: flex;
  justify-content: left;
  /* align-items: Top; */
  height: 100%;
  /* Ensure content takes up full height */
}

*this is title bar* .centered-text {
  font-size: 3.5rem;
  /* Equivalent to text-4xl */
  font-weight: bold;
  /* Equivalent to font-bold */
  margin-bottom: auto;
  display: flex;
}

*this is for imgae* .imageClass {
  width: 600px !important;
  height: 400px !important;

}

.image-container {
  align-self: flex-start;
  /* Align to the top */
}


.paragraphClass {
  margin-top: 1rem;
  /* gap between paragraphClass and sub-heading */
  margin-right: auto;
  /* Set right margin to auto to center the element horizontally */
  margin-left: auto;
  /* Set left margin to auto to center the element horizontally */
  line-height: 1.5;
  /* Increase the line height */
  text-align: left;
  /* Align the text to the left */
}

.paragraphClass+.paragraphClass {
  margin-top: 1rem;
  /* Adjust the margin-top value as needed */
}

.sub-heading {
  /* font-size: 1.875rem 34px; */
  /* Equivalent to text-3xl */
  font-weight: 600;
  /* Equivalent to font-semibold */
  margin: 10rem 0 0 auto;
  /* Horizontally center the element */
  margin-left: 6rem;
  /* Add left margin to move it to the right */
  white-space: nowrap;
  /* Prevent text from wrapping */
  overflow: hidden;
  /* Hide any text that overflows the container */
  text-overflow: ellipsis;
  /* Display ellipsis for overflowed text */
  /* font-family: Verdana, Geneva, sans-serif; */

}



*this is for button* .buttonClass {
  background-color: #246cea;
  /* Equivalent to bg-blue-500 */
  color: #f4baba;
  /* Equivalent to text-white */
  font-weight: bold;
  /* Equivalent to font-bold */
  margin-bottom: 10rem;
  /* Equivalent to py-2 */
  padding-left: 1rem;
  /* Equivalent to px-4 */
  padding-right: 3rem;
  /* Equivalent to px-4 */
  border-radius: 12.5rem;
  /* Equivalent to rounded */
  margin-left: auto;
  /* Move the button to the right side */
}

.logout-btn:hover {
  /* color:  rgb(25, 0, 255);  */
  color: rgb(255, 255, 255);
  /* Change to desired color */
  --bs-dropdown-link-active-bg: #ffffff;
}

.logout-text {
  visibility: hidden;
}

.logout-text.visible {
  visibility: visible;
}

.profile {
  text-align: right;
}

/* ======= */
.profilesidebar {
  position: fixed;
  top: 48px;
  /* Adjust top position as needed */
  right: 3px;
  width: 200px;
  /* Adjust width as needed */
  height: calc(35% - 60px);
  /* Adjust height as needed */
  /* background-color:#334d5b; */
  background-color: white;
  /*background color*/
  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); */
  box-shadow: 0 0 5px white;
  /* color: gray; */
  color: white;
  padding: 5px;
  z-index: 9;
}


.profile-info {
  padding-left: 10px;
  /* Adjust the value as needed */
}

.header-container {
  position: relative;
  /* Ensure the sidebar is positioned relative to the header */
}

.profile-icon-container {
  display: flex;
  justify-content: center;
  /* Center the content horizontally */
  align-items: center;
  /* Center the content vertically */
  cursor: pointer;
  /* Change cursor to pointer on hover */
  color: white;
}



.profile-icon {
  /* color: white; */
  color: #4d4948;
}

/* started masterupload page design */
.Masterupload-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  /* it will give space between header and footer */
}

/* ended masterupload page design */

/* started dashboard page design */
.dashboard-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  /* it will give space between header and footer */
}

/* ended dashboard page design */

/*cardheader and footer comman color background all pages*/


.card-header {
  background-color: var(--card-header-bg) !important;
  border-radius: 0px;
  color: var(--whitefont-color-card-header) !important;
  /* Text color */
  display: flex;
  /* Enable flexbox for centering */
  justify-content: center;
  /* Horizontally center the content */
  align-items: center;
  /* Vertically center the content */
  text-align: center;
  /* Ensure text is centered */
  height: 30px;
  /* Optional: Define a height for the header */
  padding: 20px 5px !important;
  font-size: var(--card-Header-Font-size);
}

.card-header-gapsy {
  /* Copy all properties from .card-header */
  border-radius: 0px;
  color: var(--whitefont-color-card-header) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 30px;
  padding: 20px 5px !important;
  font-size: var(--card-Header-Font-size);
  
  /* Only change the background color as per new requirement */
  background-color: #366872 !important;
}

.breadcrumb-item.breadcrumb-main.active {
  font-size: small;
  background: none;
}

.card-title {
  color: white !important;
  margin-top: 5px;
}


.card-footer {
  background: none !important;
}

.page-item.active .page-link,
.page-link.active {
  z-index: 3;
  color: white !important;
  /* Force the text color to be white */
  background-color: var(--navlink-hover) !important;
  /* Use your custom background color */
  border-color: var(--navlink-hover) !important;
  /* Use your custom border color */
}

.link-info:hover {
  color: var(--navlink-hover);
  /* Custom color for hover state */
  text-decoration: underline;
  /* Optional: Add underline on hover if desired */
}

.page-link {
  color: var(--navlink-hover);
}



/* Table Structure Color  */
.table th {
  background-color: var(--custom-bg) !important;
  /* Will override other background color styles */
  color: var(--table-header-txt-color) !important;
  font-size: var(--table-header-font-size) !important;
}

.notification-count-color{
  color: var(--bell-icon-number-color) !important;
}

.bell-icon{
color: var(--bell-icon-color);
cursor: pointer;
margin-bottom: 2px;


}
.header-Profile-Icon-color{
  color: var(--Profil-Icon-color);
}

.Profile-section{
font-size: var(--profile-menu-font-size);
color: var(--blackfont-color) !important;
}

.profile-section-userRole{
  font-size: var(--profile-menu-font-size);
  font-weight: bold;
  color: var(--blackfont-color) !important;
}

.profile-section-lastLogin{
  font-size: var(--profile-menu-font-size-lastLogin);
 color: var(--profile-menu-color-lastLogin);
}

.Profile-section-userName{
  color: var(--UserName-color);
}

.profile-menu-icon{
  color: var(--profile-menu-Icon-color);
}
/* .table th {
    font-size: 14px;
} */
.table td {
  font-size: var(--table-List-font-size);
}

.breadcrumb.nav-breadcrumb a{
  text-decoration: none;
  font-size: 12px;
}

.h1-Font-Size{
  font-size: var(--h1-font-size);
}
.h2-Font-Size{
  font-size: var(--h2-font-size);
}
.h3-Font-Size{
  font-size: var(--h3-font-size);
}
.h4-Font-Size{
  font-size: var(--h4-font-size);
}
.h5-Font-Size{
  font-size: var(--h5-font-size);
}
.h6-Font-Size{
  font-size: var(--h6-font-size);
}
.h7-Font-Size{
  font-size: var(--h7-font-size);
}

.preview-btn-color
{
  background-color: var(--Preview-btn-bg-color);
  color: var(--preview-btn-txt-color);
}

.Upload-btn-color{
  background-color: var(--Upload-btn-bg-color);
  color: var(--Upload-btn-txt-color);
}

.add-row-btn{
  background-color: var(--add-row-btn-color);
  color: var(--add-row-btn-txt-color);
}

.btn-delete-btn{
  background-color: var(--Delete-row-color);
  color: var(--delete-row-txt-color);
}

.update-btn{
  background-color: var(--update-btn-bg-color);
  color: var(--update-btn-txt-color);
}


/* Custom alert styles for different message types */
.custom-alert-success {
  background-color: #d4edda;
  color: #155724;
  border-color: #c3e6cb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.custom-alert-danger {
  background-color: #fbe9e7; /* Light red background */
  border-color: #f44336; /* Red border */
  color: #c62828; /* Darker red text */
}

.custom-alert-warning {
  background-color: #fff3cd; /* Light yellow background */
  border-color: #ffec3d; /* Yellow border */
  color: #856404; /* Dark yellow text */
}

.custom-alert-icon-success {
  color: #4caf50; /* Green icon */
}

.custom-alert-icon-error {
  color: #f44336; /* Red icon */
}

.custom-alert-icon-warning {
  color: #ffec3d; /* Yellow icon */
}

.custom-alert-message {
  margin-bottom: 0px;
  color: inherit;
  font-size: 16px;
}

.custom-alert-close-btn {
  width: 15px;
  height: 15px;
  font-size: 8px;
  position: absolute;
  bottom: 10px;
  right: 10px;
}

/* chatbot send button color */
.btn-gapsy-custom {
  background-color: #366872 !important;
  border-color: #366872 !important;
  color: white !important;
}

.btn-gapsy-custom:hover {
  background-color: #2a5159 !important;
  border-color: #2a5159 !important;
}

.btn-gapsy-custom:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;;AAGA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,oCAAoC;AACtC;;;AAGA;EACE;AACF;;AAEA;EACE,oCAAoC;AACtC;;;;;;AAMA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;EAClC,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gDAAgD;AAClD;;;AAGA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,6EAA6E;EAC7E,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;;AAGA,mDAAmD;AACnD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,2DAA2D;AAC7D;;AAEA,gCAAgC;;AAEhC,uCAAuC;AACvC;EACE,mCAAmC;AACrC;;;;AAIA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;;;AAIA;EACE;;;;;;uBAMqB;EACrB;;;;;;;;sBAQoB;EACpB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;;;AAIA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;AACnB;;;AAGA;EACE,eAAe;EACf,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gCAAgC;AAClC;;;;AAIA,aAAa;;AAEb;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;;AAE1B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;;AAGA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,gEAAgE;EAChE,iBAAiB;EACjB,+DAA+D;EAC/D,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,oCAAoC;EACpC,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,+CAA+C;EAC/C,uBAAuB;EACvB,yCAAyC;EACzC,8CAA8C;;AAEhD;;;;AAIA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,4BAA4B;EAC5B,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,SAAS;EACT,kCAAkC;EAClC,UAAU;EACV,YAAY;EACZ,2BAA2B;EAC3B,wBAAwB;EACxB,4BAA4B;EAC5B,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,6CAA6C;EAC7C,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;EAClC,eAAe;EACf,sCAAsC;EACtC,YAAY;AACd;;;;AAIA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA,mCAAmC;;AAEnC,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,iDAAiD;AACnD;;AAEA,gCAAgC;;AAEhC,0DAA0D;;;AAG1D;EACE,kDAAkD;EAClD,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;EACf,aAAa;EACb,iCAAiC;EACjC,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;EACZ,6CAA6C;EAC7C,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,oDAAoD;EACpD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,uCAAuC;;EAEvC,4DAA4D;EAC5D,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,UAAU;EACV,uBAAuB;EACvB,qCAAqC;EACrC,iDAAiD;EACjD,qCAAqC;EACrC,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;;;AAIA,2BAA2B;AAC3B;EACE,6CAA6C;EAC7C,gDAAgD;EAChD,+CAA+C;EAC/C,mDAAmD;AACrD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;AACA,6BAA6B;AAC7B,eAAe;AACf,kBAAkB;;;AAGlB;AACA;EACE,+BAA+B;AACjC;;AAEA;AACA,wCAAwC;AACxC,wCAAwC;AACxC;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,kDAAkD;CACnD,0CAA0C;AAC3C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;AACA;;GAEG;AACH;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;;;AAGA,oDAAoD;AACpD;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,qBAAqB,EAAE,eAAe;EACtC,cAAc,EAAE,oBAAoB;AACtC;;AAEA;EACE,yBAAyB,EAAE,4BAA4B;EACvD,qBAAqB,EAAE,kBAAkB;EACzC,cAAc,EAAE,qBAAqB;AACvC;;AAEA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,cAAc,EAAE,gBAAgB;AAClC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":["@import './assets/css/background-colors.css';\r\n\r\n.App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n\r\n.table-header-color .table .left-header {\r\n  background-color: #489469 !important;\r\n}\r\n.table-header-color .table .right-header {\r\n  background-color: #82479b !important;\r\n}\r\n\r\n.table-header-color .table .thead-left {\r\n  background-color: #18723f !important;\r\n}\r\n\r\n.table-header-color .table .thead-right {\r\n \r\n  background-color: #603174 !important;\r\n}\r\n\r\n\r\n.table-header-color .table .thead-audit {\r\n  background-color: #0a2339 !important\r\n}\r\n\r\n.table-header-color .table .audit-header {\r\n  background-color: #3d4a56 !important;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: gray;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.custom-alert-warning {\r\n  color: #856404;\r\n  /* Dark yellow text color */\r\n  background-color: #fff3cd;\r\n  /* Light yellow background color */\r\n  border-color: #ffeeba;\r\n  /* Light yellow border color */\r\n}\r\n\r\n.custom-alert-warning .btn-close {\r\n  filter: invert(50%);\r\n  /* Optional: Adjust the button color if needed */\r\n}\r\n\r\n\r\n/* Header.css */\r\n.header-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 5px 15px;\r\n  color: var(--whitefont-color);\r\n  /*header text */\r\n  background-color: var(--header-bg);\r\n  padding-bottom: 5px;\r\n  /* Optional: Adjust padding to create space between the header and the line */\r\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.3);\r\n  /* Smooth shadow effect */\r\n}\r\n\r\n.logo-default-header {\r\n  color: var(--ProductName-color);\r\n  margin-bottom: 0px;\r\n  margin-top: 0px;\r\n}\r\n\r\n.bell-default header {\r\n  color: var(--blackfont-color);\r\n}\r\n\r\n.count-default-header {\r\n  color: var(--blackfont-color);\r\n}\r\n\r\n.notification-canvas-count {\r\n  color: var(--blackfont-color);\r\n}\r\n\r\n\r\n/* ===========Header Downside border============= */\r\n.header-container::before {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 0;\r\n  /* Position it at the bottom */\r\n  left: 0;\r\n  width: 100%;\r\n  height: 0px;\r\n  /* Height of the border */\r\n  /* background-color: #E67016;  header border bottom Color */\r\n}\r\n\r\n/* ===========End============= */\r\n\r\n/* Header name changed with below css */\r\n.header-name {\r\n  font-family: 'Logirent', sans-serif;\r\n}\r\n\r\n\r\n\r\n.text-center1 {\r\n  font-family: 'Logirent Demo', sans-serif;\r\n}\r\n \r\n.header-text{\r\n  font-family: 'Logirent Demo', sans-serif;\r\n  font-size: var(--ProductName-fontsize);\r\n}\r\n\r\n.custom-margin {\r\n  margin-left: 4.3rem !important;\r\n  margin-bottom: -4px;\r\n}\r\n\r\n\r\n\r\n.logo1 {\r\n  /* position: absolute; \r\n  left: 1px;\r\n  top: 3px; \r\n  width: 35px; \r\n  height: auto; \r\n  object-fit: contain; \r\n  margin-left: 10px;  */\r\n  /* \r\n    position: absolute;\r\n    left: 9px;\r\n    top: 0px;\r\n    width: 25px;\r\n    height: auto;\r\n    object-fit: contain;\r\n    margin-left: 10px;\r\n    margin-top: 4px; */\r\n  position: absolute;\r\n  left: 1px;\r\n  top: -1px;\r\n  width: 54px;\r\n  height: auto;\r\n  object-fit: contain;\r\n  margin-left: 10px;\r\n  /* margin-top: 4px; */\r\n}\r\n\r\n\r\n.logo2{\r\n  position: absolute;\r\n  /* left: -41px; */\r\n  top: -7px;\r\n  width: 57px;\r\n  height: auto;\r\n  object-fit: contain;\r\n  margin-left: 70px;\r\n  width: 61px;\r\n}\r\n\r\n\r\n\r\n.logo3{\r\n  position: absolute;\r\n  /* left: -41px; */\r\n  top: -2px;\r\n  width: 57px;\r\n  height: auto;\r\n  object-fit: contain;\r\n  margin-left: 0px;\r\n  margin-right: 20px;\r\n  width: 61px;\r\n}\r\n\r\n.header-name1 {\r\n\r\n  margin-left: 45px;\r\n}\r\n\r\n\r\n.profile-icon {\r\n  cursor: pointer;\r\n  /* Optional: Add cursor pointer */\r\n}\r\n\r\n/* Header.css */\r\n.profile-icon {\r\n  font-size: 2rem;\r\n  /* Adjust the size as needed */\r\n}\r\n\r\n.footer-name {\r\n  font-size: 10px;\r\n  /* Adjust the font size as needed */\r\n  padding-left: 10px;\r\n  /* Adjust the padding as needed */\r\n  margin-left: 10px;\r\n  /* Adjust the margin as needed */\r\n}\r\n\r\n\r\n\r\n/* Home.css */\r\n\r\n.home-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  background-color: #f0f0f0e6;\r\n}\r\n\r\n.content {\r\n  flex: 1;\r\n  /* Add styles for your page content if needed */\r\n}\r\n\r\n.footer {\r\n  margin-top: auto;\r\n}\r\n\r\n.content {\r\n  display: flex;\r\n  justify-content: left;\r\n  /* align-items: Top; */\r\n  height: 100%;\r\n  /* Ensure content takes up full height */\r\n}\r\n\r\n*this is title bar* .centered-text {\r\n  font-size: 3.5rem;\r\n  /* Equivalent to text-4xl */\r\n  font-weight: bold;\r\n  /* Equivalent to font-bold */\r\n  margin-bottom: auto;\r\n  display: flex;\r\n}\r\n\r\n*this is for imgae* .imageClass {\r\n  width: 600px !important;\r\n  height: 400px !important;\r\n\r\n}\r\n\r\n.image-container {\r\n  align-self: flex-start;\r\n  /* Align to the top */\r\n}\r\n\r\n\r\n.paragraphClass {\r\n  margin-top: 1rem;\r\n  /* gap between paragraphClass and sub-heading */\r\n  margin-right: auto;\r\n  /* Set right margin to auto to center the element horizontally */\r\n  margin-left: auto;\r\n  /* Set left margin to auto to center the element horizontally */\r\n  line-height: 1.5;\r\n  /* Increase the line height */\r\n  text-align: left;\r\n  /* Align the text to the left */\r\n}\r\n\r\n.paragraphClass+.paragraphClass {\r\n  margin-top: 1rem;\r\n  /* Adjust the margin-top value as needed */\r\n}\r\n\r\n.sub-heading {\r\n  /* font-size: 1.875rem 34px; */\r\n  /* Equivalent to text-3xl */\r\n  font-weight: 600;\r\n  /* Equivalent to font-semibold */\r\n  margin: 10rem 0 0 auto;\r\n  /* Horizontally center the element */\r\n  margin-left: 6rem;\r\n  /* Add left margin to move it to the right */\r\n  white-space: nowrap;\r\n  /* Prevent text from wrapping */\r\n  overflow: hidden;\r\n  /* Hide any text that overflows the container */\r\n  text-overflow: ellipsis;\r\n  /* Display ellipsis for overflowed text */\r\n  /* font-family: Verdana, Geneva, sans-serif; */\r\n\r\n}\r\n\r\n\r\n\r\n*this is for button* .buttonClass {\r\n  background-color: #246cea;\r\n  /* Equivalent to bg-blue-500 */\r\n  color: #f4baba;\r\n  /* Equivalent to text-white */\r\n  font-weight: bold;\r\n  /* Equivalent to font-bold */\r\n  margin-bottom: 10rem;\r\n  /* Equivalent to py-2 */\r\n  padding-left: 1rem;\r\n  /* Equivalent to px-4 */\r\n  padding-right: 3rem;\r\n  /* Equivalent to px-4 */\r\n  border-radius: 12.5rem;\r\n  /* Equivalent to rounded */\r\n  margin-left: auto;\r\n  /* Move the button to the right side */\r\n}\r\n\r\n.logout-btn:hover {\r\n  /* color:  rgb(25, 0, 255);  */\r\n  color: rgb(255, 255, 255);\r\n  /* Change to desired color */\r\n  --bs-dropdown-link-active-bg: #ffffff;\r\n}\r\n\r\n.logout-text {\r\n  visibility: hidden;\r\n}\r\n\r\n.logout-text.visible {\r\n  visibility: visible;\r\n}\r\n\r\n.profile {\r\n  text-align: right;\r\n}\r\n\r\n/* ======= */\r\n.profilesidebar {\r\n  position: fixed;\r\n  top: 48px;\r\n  /* Adjust top position as needed */\r\n  right: 3px;\r\n  width: 200px;\r\n  /* Adjust width as needed */\r\n  height: calc(35% - 60px);\r\n  /* Adjust height as needed */\r\n  /* background-color:#334d5b; */\r\n  background-color: white;\r\n  /*background color*/\r\n  /* box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); */\r\n  box-shadow: 0 0 5px white;\r\n  /* color: gray; */\r\n  color: white;\r\n  padding: 5px;\r\n  z-index: 9;\r\n}\r\n\r\n\r\n.profile-info {\r\n  padding-left: 10px;\r\n  /* Adjust the value as needed */\r\n}\r\n\r\n.header-container {\r\n  position: relative;\r\n  /* Ensure the sidebar is positioned relative to the header */\r\n}\r\n\r\n.profile-icon-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  /* Center the content horizontally */\r\n  align-items: center;\r\n  /* Center the content vertically */\r\n  cursor: pointer;\r\n  /* Change cursor to pointer on hover */\r\n  color: white;\r\n}\r\n\r\n\r\n\r\n.profile-icon {\r\n  /* color: white; */\r\n  color: #4d4948;\r\n}\r\n\r\n/* started masterupload page design */\r\n.Masterupload-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  justify-content: space-between;\r\n  /* it will give space between header and footer */\r\n}\r\n\r\n/* ended masterupload page design */\r\n\r\n/* started dashboard page design */\r\n.dashboard-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 100vh;\r\n  justify-content: space-between;\r\n  /* it will give space between header and footer */\r\n}\r\n\r\n/* ended dashboard page design */\r\n\r\n/*cardheader and footer comman color background all pages*/\r\n\r\n\r\n.card-header {\r\n  background-color: var(--card-header-bg) !important;\r\n  border-radius: 0px;\r\n  color: var(--whitefont-color-card-header) !important;\r\n  /* Text color */\r\n  display: flex;\r\n  /* Enable flexbox for centering */\r\n  justify-content: center;\r\n  /* Horizontally center the content */\r\n  align-items: center;\r\n  /* Vertically center the content */\r\n  text-align: center;\r\n  /* Ensure text is centered */\r\n  height: 30px;\r\n  /* Optional: Define a height for the header */\r\n  padding: 20px 5px !important;\r\n  font-size: var(--card-Header-Font-size);\r\n}\r\n\r\n.card-header-gapsy {\r\n  /* Copy all properties from .card-header */\r\n  border-radius: 0px;\r\n  color: var(--whitefont-color-card-header) !important;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-align: center;\r\n  height: 30px;\r\n  padding: 20px 5px !important;\r\n  font-size: var(--card-Header-Font-size);\r\n  \r\n  /* Only change the background color as per new requirement */\r\n  background-color: #366872 !important;\r\n}\r\n\r\n.breadcrumb-item.breadcrumb-main.active {\r\n  font-size: small;\r\n  background: none;\r\n}\r\n\r\n.card-title {\r\n  color: white !important;\r\n  margin-top: 5px;\r\n}\r\n\r\n\r\n.card-footer {\r\n  background: none !important;\r\n}\r\n\r\n.page-item.active .page-link,\r\n.page-link.active {\r\n  z-index: 3;\r\n  color: white !important;\r\n  /* Force the text color to be white */\r\n  background-color: var(--navlink-hover) !important;\r\n  /* Use your custom background color */\r\n  border-color: var(--navlink-hover) !important;\r\n  /* Use your custom border color */\r\n}\r\n\r\n.link-info:hover {\r\n  color: var(--navlink-hover);\r\n  /* Custom color for hover state */\r\n  text-decoration: underline;\r\n  /* Optional: Add underline on hover if desired */\r\n}\r\n\r\n.page-link {\r\n  color: var(--navlink-hover);\r\n}\r\n\r\n\r\n\r\n/* Table Structure Color  */\r\n.table th {\r\n  background-color: var(--custom-bg) !important;\r\n  /* Will override other background color styles */\r\n  color: var(--table-header-txt-color) !important;\r\n  font-size: var(--table-header-font-size) !important;\r\n}\r\n\r\n.notification-count-color{\r\n  color: var(--bell-icon-number-color) !important;\r\n}\r\n\r\n.bell-icon{\r\ncolor: var(--bell-icon-color);\r\ncursor: pointer;\r\nmargin-bottom: 2px;\r\n\r\n\r\n}\r\n.header-Profile-Icon-color{\r\n  color: var(--Profil-Icon-color);\r\n}\r\n\r\n.Profile-section{\r\nfont-size: var(--profile-menu-font-size);\r\ncolor: var(--blackfont-color) !important;\r\n}\r\n\r\n.profile-section-userRole{\r\n  font-size: var(--profile-menu-font-size);\r\n  font-weight: bold;\r\n  color: var(--blackfont-color) !important;\r\n}\r\n\r\n.profile-section-lastLogin{\r\n  font-size: var(--profile-menu-font-size-lastLogin);\r\n color: var(--profile-menu-color-lastLogin);\r\n}\r\n\r\n.Profile-section-userName{\r\n  color: var(--UserName-color);\r\n}\r\n\r\n.profile-menu-icon{\r\n  color: var(--profile-menu-Icon-color);\r\n}\r\n/* .table th {\r\n    font-size: 14px;\r\n} */\r\n.table td {\r\n  font-size: var(--table-List-font-size);\r\n}\r\n\r\n.breadcrumb.nav-breadcrumb a{\r\n  text-decoration: none;\r\n  font-size: 12px;\r\n}\r\n\r\n.h1-Font-Size{\r\n  font-size: var(--h1-font-size);\r\n}\r\n.h2-Font-Size{\r\n  font-size: var(--h2-font-size);\r\n}\r\n.h3-Font-Size{\r\n  font-size: var(--h3-font-size);\r\n}\r\n.h4-Font-Size{\r\n  font-size: var(--h4-font-size);\r\n}\r\n.h5-Font-Size{\r\n  font-size: var(--h5-font-size);\r\n}\r\n.h6-Font-Size{\r\n  font-size: var(--h6-font-size);\r\n}\r\n.h7-Font-Size{\r\n  font-size: var(--h7-font-size);\r\n}\r\n\r\n.preview-btn-color\r\n{\r\n  background-color: var(--Preview-btn-bg-color);\r\n  color: var(--preview-btn-txt-color);\r\n}\r\n\r\n.Upload-btn-color{\r\n  background-color: var(--Upload-btn-bg-color);\r\n  color: var(--Upload-btn-txt-color);\r\n}\r\n\r\n.add-row-btn{\r\n  background-color: var(--add-row-btn-color);\r\n  color: var(--add-row-btn-txt-color);\r\n}\r\n\r\n.btn-delete-btn{\r\n  background-color: var(--Delete-row-color);\r\n  color: var(--delete-row-txt-color);\r\n}\r\n\r\n.update-btn{\r\n  background-color: var(--update-btn-bg-color);\r\n  color: var(--update-btn-txt-color);\r\n}\r\n\r\n\r\n/* Custom alert styles for different message types */\r\n.custom-alert-success {\r\n  background-color: #d4edda;\r\n  color: #155724;\r\n  border-color: #c3e6cb;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.custom-alert-danger {\r\n  background-color: #fbe9e7; /* Light red background */\r\n  border-color: #f44336; /* Red border */\r\n  color: #c62828; /* Darker red text */\r\n}\r\n\r\n.custom-alert-warning {\r\n  background-color: #fff3cd; /* Light yellow background */\r\n  border-color: #ffec3d; /* Yellow border */\r\n  color: #856404; /* Dark yellow text */\r\n}\r\n\r\n.custom-alert-icon-success {\r\n  color: #4caf50; /* Green icon */\r\n}\r\n\r\n.custom-alert-icon-error {\r\n  color: #f44336; /* Red icon */\r\n}\r\n\r\n.custom-alert-icon-warning {\r\n  color: #ffec3d; /* Yellow icon */\r\n}\r\n\r\n.custom-alert-message {\r\n  margin-bottom: 0px;\r\n  color: inherit;\r\n  font-size: 16px;\r\n}\r\n\r\n.custom-alert-close-btn {\r\n  width: 15px;\r\n  height: 15px;\r\n  font-size: 8px;\r\n  position: absolute;\r\n  bottom: 10px;\r\n  right: 10px;\r\n}\r\n\r\n/* chatbot send button color */\r\n.btn-gapsy-custom {\r\n  background-color: #366872 !important;\r\n  border-color: #366872 !important;\r\n  color: white !important;\r\n}\r\n\r\n.btn-gapsy-custom:hover {\r\n  background-color: #2a5159 !important;\r\n  border-color: #2a5159 !important;\r\n}\r\n\r\n.btn-gapsy-custom:disabled {\r\n  opacity: 0.65;\r\n  cursor: not-allowed;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
